import localStorageService from '../localStorage';
import { HP_IMPRESSIONS_KEY, IMPRESSION_EVENT, THRESHOLD_IMPRESSIONS, CLICK_IMPRESSION_EVENT, TEMP_STORAGE_KEY, VALID_THRESHOLD, HP_IMPRESSIONS_KEY_V2, IMPRESSION_EVENT_V2, } from './constants';
const NEW_IMPRESSION_BASE_DATA = {
    event: IMPRESSION_EVENT,
    impressions: 1,
};
const NEW_IMPRESSION_BASE_DATA_V2 = {
    event: IMPRESSION_EVENT_V2,
    impressions: 1,
};
const CLICK_IMPRESSION_BASE = {
    event: CLICK_IMPRESSION_EVENT,
    clicks: 1,
};
const getTimeStamp = () => (+new Date());
class ImpressionsHandler {
}
ImpressionsHandler.syncCallback = null;
ImpressionsHandler.initialize = (asyncCallback, syncCallback) => {
    ImpressionsHandler.callback = asyncCallback;
    if (syncCallback) {
        ImpressionsHandler.syncCallback = syncCallback;
    }
};
ImpressionsHandler.initializeImpressionEvent = (eventName) => {
    if (eventName) {
        ImpressionsHandler.impressionEvent = eventName;
    }
};
ImpressionsHandler.pushImpressions = (storageKey = HP_IMPRESSIONS_KEY) => {
    const dataInStorage = localStorageService.getItem(storageKey);
    if (dataInStorage) {
        localStorageService.removeItem(storageKey);
        const parsedStorageData = JSON.parse(dataInStorage);
        if (parsedStorageData) {
            const impressionKeys = Object.keys(parsedStorageData);
            const impressions = [];
            impressionKeys.forEach((impressionItem) => {
                const impression = parsedStorageData[impressionItem];
                if (impression) {
                    if (impression.tStamp) {
                        impression.timestamp = (impression.tStamp / 1000);
                        delete impression.tStamp;
                    }
                    impressions.push(impression);
                }
            });
            if (ImpressionsHandler.callback) {
                if (impressions.length > 0) {
                    ImpressionsHandler.callback(impressions)
                        .catch(() => {
                        // ? This was commented as per request from deals team
                        // * Since this can cause stale data from being pushed to log
                        // ImpressionsHandler.restoreImpressions(impressions);
                    });
                }
            }
            else {
                // eslint-disable-next-line no-console
                console.warn('Callback not provided for ImpressionHandler');
            }
        }
    }
};
ImpressionsHandler.handleImpression = (impressionData, storageKey = HP_IMPRESSIONS_KEY, baseData = NEW_IMPRESSION_BASE_DATA, updateEvent = true) => {
    const { transaction_id: transactionId } = impressionData;
    const dataInStorage = localStorageService.getItem(storageKey);
    const newImpression = Object.assign(Object.assign(Object.assign(Object.assign({}, impressionData), baseData), ((updateEvent) && ImpressionsHandler.impressionEvent && {
        event: ImpressionsHandler.impressionEvent,
    })), { timestamp: (getTimeStamp() / 1000) });
    if (ImpressionsHandler.syncCallback) {
        ImpressionsHandler.syncCallback([newImpression]);
    }
    if (dataInStorage) {
        const parsedStorageData = JSON.parse(dataInStorage);
        if (parsedStorageData) {
            const targetData = parsedStorageData[transactionId];
            if (targetData) {
                const { impressions } = targetData;
                targetData.impressions = impressions + 1;
                targetData.timestamp = (getTimeStamp() / 1000);
            }
            else {
                parsedStorageData[transactionId] = newImpression;
            }
            localStorageService.setItem(storageKey, JSON.stringify(parsedStorageData));
            const numberOfUniqueImpressions = Object.keys(parsedStorageData).length;
            if (numberOfUniqueImpressions >= THRESHOLD_IMPRESSIONS) {
                ImpressionsHandler.pushImpressions(storageKey);
            }
            return;
        }
    }
    const dataToStore = {
        [transactionId]: newImpression,
    };
    const stringifiedDataToStore = JSON.stringify(dataToStore);
    localStorageService.setItem(storageKey, stringifiedDataToStore);
};
ImpressionsHandler.handleImpressionV2 = (impressionData) => {
    const impData = impressionData;
    impData.tStamp = getTimeStamp();
    const { transaction_id: transactionId } = impressionData;
    const dataInStorage = localStorageService.getItem(TEMP_STORAGE_KEY);
    if (dataInStorage) {
        const parsedStorageData = JSON.parse(dataInStorage);
        if (parsedStorageData) {
            const newImpression = Object.assign(Object.assign({}, impData), NEW_IMPRESSION_BASE_DATA_V2);
            parsedStorageData[transactionId] = newImpression;
            localStorageService.setItem(TEMP_STORAGE_KEY, JSON.stringify(parsedStorageData));
            // const numberOfUniqueImpressions = Object.keys(parsedStorageData).length;
            // if (numberOfUniqueImpressions >= THRESHOLD_IMPRESSIONS) {
            //   ImpressionsHandler.pushImpressions();
            // }
            return;
        }
    }
    const newImpression = Object.assign(Object.assign(Object.assign({}, impData), NEW_IMPRESSION_BASE_DATA_V2), (ImpressionsHandler.impressionEvent && {
        event: ImpressionsHandler.impressionEvent,
    }));
    const dataToStore = {
        [transactionId]: newImpression,
    };
    const stringifiedDataToStore = JSON.stringify(dataToStore);
    localStorageService.setItem(TEMP_STORAGE_KEY, stringifiedDataToStore);
};
ImpressionsHandler.removeImpression = (impressionData) => {
    const { transaction_id: transactionId } = impressionData;
    const timeStamp = getTimeStamp();
    const dataInStorage = localStorageService.getItem(TEMP_STORAGE_KEY);
    if (dataInStorage) {
        const parsedStorageData = JSON.parse(dataInStorage);
        if (parsedStorageData) {
            const targetData = parsedStorageData[transactionId];
            if (targetData) {
                const isValid = ImpressionsHandler.isValidImpression(targetData.tStamp, timeStamp);
                if (isValid) {
                    ImpressionsHandler.handleImpression(targetData, HP_IMPRESSIONS_KEY_V2, NEW_IMPRESSION_BASE_DATA_V2, false);
                }
                delete parsedStorageData[transactionId];
                const stringifiedDataToStore = JSON.stringify(parsedStorageData);
                localStorageService.setItem(TEMP_STORAGE_KEY, stringifiedDataToStore);
            }
        }
    }
};
ImpressionsHandler.dataCollector = () => {
    const timeStamp = getTimeStamp();
    const dataInStorage = localStorageService.getItem(TEMP_STORAGE_KEY);
    if (dataInStorage) {
        const parsedStorageData = JSON.parse(dataInStorage);
        if (parsedStorageData) {
            Object.keys(parsedStorageData).forEach((key) => {
                const targetData = parsedStorageData[key];
                if (targetData) {
                    const isValid = ImpressionsHandler.isValidImpression(targetData.tStamp, timeStamp);
                    if (isValid) {
                        ImpressionsHandler.handleImpression(targetData, HP_IMPRESSIONS_KEY_V2, NEW_IMPRESSION_BASE_DATA_V2, false);
                        delete parsedStorageData[key];
                    }
                }
            });
            const stringifiedDataToStore = JSON.stringify(parsedStorageData);
            localStorageService.setItem(TEMP_STORAGE_KEY, stringifiedDataToStore);
        }
    }
};
ImpressionsHandler.handleClick = (impressionData) => {
    const clickImpression = Object.assign(Object.assign({}, impressionData), CLICK_IMPRESSION_BASE);
    if (ImpressionsHandler.callback) {
        return ImpressionsHandler.callback([clickImpression]);
    }
    return new Promise((resolve) => {
        resolve('Callback Not Provided');
    });
};
ImpressionsHandler.isValidImpression = (existTimeStamp, newTimeStamp) => {
    const diff = ((newTimeStamp || 0) - (existTimeStamp || 0));
    if (diff && (diff >= VALID_THRESHOLD)) {
        return true;
    }
    return false;
};
export default ImpressionsHandler;
